<template>
  <div class="cover-right-detached media-small">
    <div class="layer content-container">
      <div class="content-box">
        <slot name="header"></slot>
        <slot name="jobCounter"></slot>
        <slot name="ctaButton"></slot>
        <slot name="search"></slot>
      </div>
    </div>

    <div class="layer media-container">
      <slot name="media"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoverRightDetached",
};
</script>

<style lang="scss" scoped>
@import "../scss/shared";
@import "../scss/media-small";

.media-container {
  padding-right: 64px;
}
</style>
